export enum TextAlignTypes {
  none = "none",
  innerAlign = "innerAlign",
  centerAlign = "centerAlign",
  mixedAlign = "mixedAlign"
}

